export default __webpack_public_path__ + "static/media/location-pin-alt 1.3c557677.svg";